import EventBanner from "../../../public/banners/2434_only_hk_banner.jpg";

export default {
  date: "28-10-2022",
  description:
    "2434 Only HK 將於11月6號在觀塘第一次舉辦同人活動，活動內容有同人攤位、舞台表演、互動遊戲及展覽等，有興趣的朋友請必務要多多支持﹗",
  images: {},
  mainImage: EventBanner,
  title: "2434 Only HK 將於11月6號舉辦🎉",
  mdContent: `
2434 Only HK 將於11月6號在觀塘第一次舉辦同人活動，活動內容有同人攤位、舞台表演、互動遊戲及展覽等，有興趣的朋友請必務要多多支持﹗

---

## 關於活動的詳情如下：

- 活動日期： 2022年11月6日 (日)
- 活動時間： 12:00 - 19:00（VIP入場時間：11:00）
- 活動地點： THE WAVE 8/F

目前所有門票預售已完結，當日仍有少量一般門票可供即場購買，售完即止。未有成功購買預售門票的人士可以考慮於當日來場購票。

## [即埸一般門票]

- 門票開售時間： 12:00
- 最早可入場時間： 12:00 （實際入場時間按籌號指示）
- **每人限購最多2張**

留意當日一般門票的開售時間為12:00。
因應政府的防疫措施，請各位不要早於12:00前來到會場聚集。所有的自行整列隊伍大會均不承認，請聽從當日的大會工作人員指示以維持場地秩序和保持活動運作暢順。

---

如想了解更多活動，可以瀏覽活動網頁：<https://2434onlyhk.weebly.com>

另外於Facebook和Instagram上都會陸續公佈參加活動的同人組織，大家都可以按追蹤和讚好以便接收資訊。
  `,
  mdInfo: `
# 活動資訊

**2434 Only HK 主頁：<https://2434onlyhk.weebly.com>**
**Facebook：<https://www.facebook.com/2434onlyhk>**
**Instagram：<https://www.instagram.com/2434onlyhk>**
  `,
};
